/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { setSkipValidateCart } from './ValidateCart-Actions';

const initalState = {
    skipValidateCart: false,
};

const validateCartReducer = (state = initalState, action) => {
    switch (action.type) {
        case setSkipValidateCart().type: {
            return { ...state, skipValidateCart: action.data };
        }
        default:
            return state;
    }
};

export default validateCartReducer;
